export default {
  base: ({ theme }) => `1px solid ${theme.color.border.default}`,
  thick: ({ theme }) => `2px solid ${theme.color.border.default}`,
}
